var render = function render(){var _vm=this,_c=_vm._self._c;return _c('issue-severity',{staticClass:"issue-severity column",attrs:{"issue":_vm.item,"is-translation":_vm.isTranslation}})
}
var staticRenderFns = []

export { render, staticRenderFns }